// Features/Klaviyo/mod.ts
window.klaviyo ??= {};
klaviyo.init({
  platform: "shopify",
  account: "TpuDet"
});
klaviyo.enable("backinstock", {
  trigger: {
    product_page_text_align: "center",
    product_page_margin: `0px`,
    product_page_class: "btn",
    product_page_text: `Benachrichtige mich, wenn verf\xFCgbar`,
    replace_anchor: false
  },
  modal: {
    subscription_success_label: `You're in! Wir schreiben dir eine E-Mail, sobald der Artikel wieder verf\xFCgbar ist.`,
    email_field_label: `E-Mail`,
    footer_content: ``,
    body_content: `Registriere dich, um eine Benachrichtigung zu erhalten, wenn dieser Artikel wieder auf Lager ist.`,
    button_label: `Benachrichtige mich`,
    headline: `{product_name}`,
    success_background_color: "#d3efcd",
    button_background_color: "#B1A696",
    error_background_color: "#fcd6d7",
    drop_background_color: "#ECE9E4",
    success_text_color: "#1B9500",
    close_button_color: "#ccc",
    button_text_color: "#fff",
    error_text_color: "#C72E2F",
    background_color: "#ECE9E4",
    text_color: "#B1A696"
  }
});
